import { createGlobalStyle } from 'styled-components';
import { SCROLLBAR_WIDTH } from '../../../common/constants';

export const GlobalStyle = createGlobalStyle`
	html, body {
		position: relative;
		height: 100%;
		overflow-y hidden;
	}

	#root {
		height: 100%;
	}

	.scroll-visible ::-webkit-scrollbar {
		width: ${SCROLLBAR_WIDTH}px;
		height: ${SCROLLBAR_WIDTH}px;
	}

	.scroll-visible ::-webkit-scrollbar-thumb {
		background: #9ca5b6;
		border-radius: ${SCROLLBAR_WIDTH}px;
	}

	::selection {
		background: #1787FF;
		color: white;
	}

	.click-effect {
		position: absolute;
		z-index: 10000;
		width: 20px;
		height: 20px;
		background: rgba(255, 165, 0, 0.7);
		border-radius: 50%;
		pointer-events: none;
		transform: translate(-50%, -50%) scale(1);
		animation: clickAnim 0.5s forwards;
	}

	@keyframes clickAnim {
		0% {
			transform: translate(-50%, -50%) scale(1);
			opacity: 1;
		}
		100% {
			transform: translate(-50%, -50%) scale(3);
			opacity: 0;
		}
	}
`
